<template>
  <div class="bg-neutral min-h-screen font-sans">
    <div class="container mx-auto px-4 py-8 max-w-md">
      <!-- 头部 -->
      <header class="text-center mb-12 mt-8">
        <div class="w-16 h-16 bg-gradient-blue rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
          <i class="fa fa-comments text-white text-2xl"></i>
        </div>
        <h1 class="text-[clamp(1.5rem,3vw,2rem)] font-bold text-dark mb-2">联系客服</h1>
        <p class="text-gray-500 text-sm">请输入设备号/卡号以咨询问题</p>
      </header>

      <!-- 表单 -->
      <form @submit.prevent="submitForm" class="space-y-6">
        <!-- 手机号输入 -->
        <div class="relative">
          <div class="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
            <van-icon name="phone-o" />
          </div>
          <input v-model="phone" style="border:1px solid #d1d5db;" placeholder="请输入设备号"
            class="w-full py-4 pl-12 pr-4 bg-white border border-gray-300 rounded-xl focus:outline-none focus:input-focus transition-all duration-300 text-dark"
            maxlength="11" @input="validatePhone">
          <div v-if="phoneError" class="absolute -bottom-5 left-0 text-danger text-xs">
            {{ phoneError }}
          </div>
        </div>

        <!-- 登录按钮 -->
        <button type="submit" style="background: linear-gradient(135deg, #165DFF 0%, #36BFFA 100%);"
          class="bg-gradient-blue w-full bg-primary hover:bg-primary/90 text-white font-medium py-4 px-6 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl hover:shadow-primary/20 btn-hover"
          :disabled="!isFormValid">
          立即转人工客服
        </button>

        <!-- 底部说明 -->
        <div class="text-center text-gray-500 text-xs mt-8">
          <p>设备号/卡号 在设备背面查询</p>
        </div>
      </form>

      <!-- 底部联系信息 -->
      <footer class="text-center text-gray-400 text-xs mt-16 mb-6">
        <p>在线客服时间：9:00 - 23.00 </p>
      </footer>

      <!-- 加载提示 -->
      <div v-if="loading" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white p-6 rounded-xl shadow-2xl flex flex-col items-center">
          <div class="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mb-4"></div>
          <p class="text-dark font-medium">正在连接客服，请稍候...</p>
        </div>
      </div>

      <!-- 成功提示 -->
      <div v-if="showSuccess" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white p-6 rounded-xl shadow-2xl max-w-xs w-full">
          <div class="text-center">
            <div class="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <i class="fa fa-check text-success text-2xl"></i>
            </div>
            <h3 class="text-dark font-bold text-lg mb-2">提交成功</h3>
            <p class="text-gray-500 text-sm mb-6">我们将尽快与您取得联系，请保持电话畅通</p>
            <button @click="closeSuccess" class="w-full bg-primary text-white py-2 rounded-lg font-medium btn-hover">
              确定
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant'
export default {
  name: 'ContactCustomerService',
  data() {
    return {
      phone: '',
      phoneError: '',
      loading: false,
      showSuccess: false,
    }
  },
  computed: {
    isFormValid() {
      return this.phone && !this.phoneError;
    }
  },
  methods: {
    validatePhone() {

    },

    submitForm() {
      wxRequest("/kefu/toSelectKefu", {iccid:this.phone}, "post").then(res => {
        if (res.data.code == 200) {
          window.location.href = res.data.data;
        } else {
          Toast.fail(res.data.message)
        }
      });

    },

    closeSuccess() {
      this.showSuccess = false;
    },

    showToast(message) {
      const toast = document.createElement('div');
      toast.className = 'fixed bottom-10 left-1/2 transform -translate-x-1/2 bg-dark text-white py-2 px-4 rounded-lg shadow-lg text-sm z-50';
      toast.textContent = message;
      document.body.appendChild(toast);

      setTimeout(() => {
        toast.classList.add('opacity-0', 'transition-opacity', 'duration-500');
        setTimeout(() => {
          document.body.removeChild(toast);
        }, 500);
      }, 2000);
    }
  }
}
</script>
  
<style>
@layer utilities {
  .content-auto {
    content-visibility: auto;
  }

  .text-shadow {
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .bg-gradient-blue {
    background: linear-gradient(135deg, #165DFF 0%, #36BFFA 100%);
  }

  .input-focus {
    @apply border-primary ring-2 ring-primary/20;
  }

  .btn-hover {
    @apply transform hover:scale-105 transition-all duration-300;
  }
}
</style>